<template>
  <a-card :bordered="false">
    <a-empty
      v-show="queryParam.facilityTypeId == ''"
      :description="this.$t('msg.I_K0402002_01')"
      style="margin: calc(10% - 32px) 0px 10%"
    />
    <div v-show="queryParam.facilityTypeId != ''" style="margin-top: -15px">
      <div class="table-page-search-wrapper">
        <!-- 検索エリア -->
        <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
          <a-row :gutter="24">
            <a-col :sm="24" :md="10" :lg="8" :xl="14" :xxl="12">
              <!--  施設情報画面の検索をクリックの場合、検索処理を行う-->
              <!-- 施設情報画面の検索をクリックの場合、検索処理を行う -->
              <!-- 一覧.备注：施設情報.备注 -->
              <!-- 一覧.ソート順：施設情報.ソート順 -->
              <!-- 一覧.施設ID （隠し）：施設情報.施設ID  -->
              <a-form-model-item :label="this.$t('disp.ficilityName')">
                <a-input
                  :placeholder="this.$t('disp.facilityNameSearch')"
                  v-model="queryParam.facilityName"
                  :maxLength="90"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :sm="24" :md="14" :lg="16" :xl="10" :xxl="12">
              <!-- 検索ボタン -->
              <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                $t('disp.btn.search')
              }}</a-button>
              <!-- リセットボタン -->
              <!-- 施設情報の「リセット」をクリックする -->
              <!-- 施設情報エリアの検索条件を全部初期化する -->
              <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <!-- 追加ボタン -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>
      </div>
      <!-- テーブル-begin -->
      <div>
        <a-table
          ref="table"
          tableLayout="auto"
          class="action font-size-13"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          @change="handleTableChange"
        >
          <div slot="action" slot-scope="text, record" style="white-space: nowrap">
            <!-- 編集ボタン -->
            <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>
            <a-divider type="vertical" />
            <!-- ダイアログ -->
            <a-popconfirm
              placement="topRight"
              :title="$t('msg.confirm.delete')"
              @confirm="() => handleDelete(record.id)"
            >
              <!-- 削除ボタン -->
              <a>{{ $t('disp.btn.delete') }}</a>
            </a-popconfirm>
          </div>
        </a-table>
      </div>
      <!-- table-end -->
      <facility-modal ref="modalForm" @emit="modalFormOk"></facility-modal>
    </div>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { getAction, postAction, deleteAction, putAction } from '@/api/manage'
import FacilityModal from './FacilityModal.vue'
import { queryPost } from '@/api/api'

export default {
  name: 'FacilityManageInfo',
  mixins: [tableMixin],
  components: {
    FacilityModal,
  },
  data() {
    return {
      // model
      model: {},
      // 施設種別
      disableMixinSearchQuery: true,
      columns: [
        {
          //施設名称
          title: this.$t('disp.ficilityName'),
          dataIndex: 'facilityName',
        },
        {
          //备注
          title: this.$t('disp.note'),
          dataIndex: 'memo',
        },
        {
          //参考人数
          title: '参考人数',
          dataIndex: 'peopleNumberMax',
          align: 'center',
          width: '100px',
        },
        {
          //ソート順
          title: this.$t('disp.sort'),
          dataIndex: 'sortOrder',
          align: 'center',
          width: '100px',
        },
        {
          title: this.$t('disp.operation'),
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      queryParam: {
        facilityName: '',
        facilityTypeId: '',
      },
      url: {
        imgerver: window._CONFIG['staticDomainURL'],
        // 検索
        list: '/kgms/k04/FacilitiesManage/queryFacilities',
        // 削除
        delete: '/kgms/k04/FacilitiesManage/deleteFacility',
      },
    }
  },
  methods: {
    /**
     * 削除
     */
    handleDelete: function (facilityId) {
      if (!this.url.delete) {
        this.$message.error(this.$t('disp.setUrlDelete'))
        return
      }
      var that = this
      deleteAction(that.url.delete, { facilityId: facilityId }).then((res) => {
        if (res.success) {
          // 内容：削除しました。
          that.$message.success(that.$t(res.message))
          if (that.selectedRowKeys.length > 0) {
            for (let i = 0; i < that.selectedRowKeys.length; i++) {
              if (that.selectedRowKeys[i] == facilityId) {
                that.selectedRowKeys.splice(i, 1)
                break
              }
            }
          }
          that.searchQuery(true, false)
        }
      })
    },
    /**
     * オープン
     */
    open(record) {
      this.queryParam.facilityTypeId = record.id
      this.$refs.modalForm.data = record
      this.searchQuery(false, false)
    },
    searchReset() {
      this.queryParam.facilityName = undefined
    },
  },
}
</script>
<style lang="less" scoped>
.ant-card {
  margin-left: -10px;
}

:global(.ant-select) {
  :global(.ant-select-selection) {
    background-color: transparent;
    border: none;
    cursor: pointer;
    box-shadow: none;

    :global(input.ant-select-search__field) {
      width: 0px;
    }
  }
}
</style>
